// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.clip-editor-page {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: #1a1a1a;
  color: #fff;
  overflow: hidden;
}

.clip-editor-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  background: #2a2a2a;
  border-bottom: 1px solid #444;
  box-shadow: 0 2px 4px rgba(0,0,0,0.3);
  flex-shrink: 0;
}

.clip-editor-title {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin: 0;
  color: #fff;
  font-size: 1.5rem;
  font-weight: 600;
}

.clip-editor-title .icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #007bff, #0056b3);
  border-radius: 8px;
  color: white;
}

.header-actions {
  display: flex;
  gap: 1rem;
}

.back-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: #6c757d;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background-color 0.2s;
}

.back-button:hover {
  background: #5a6268;
}

.clip-editor-main {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding: 0.5rem;
  gap: 0.5rem;
}

/* Video Canvas */
.video-canvas-container {
  flex: 1 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #000;
  border-radius: 8px;
  overflow: hidden;
  min-height: 300px;
  max-height: 60vh;
}

/* Custom scrollbars for video canvas container */
.video-canvas-container::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}

.video-canvas-container::-webkit-scrollbar-track {
  background: #1a1a1a;
  border-radius: 6px;
}

.video-canvas-container::-webkit-scrollbar-thumb {
  background: #444;
  border-radius: 6px;
  border: 2px solid #1a1a1a;
}

.video-canvas-container::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.video-canvas-container::-webkit-scrollbar-corner {
  background: #1a1a1a;
}

.video-preview {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  background: #000;
  min-width: min-content;
  min-height: min-content;
}

.video-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  color: #ccc;
  z-index: 10;
}

.video-loading p {
  margin: 0;
  font-size: 1rem;
}

.video-loading small {
  color: #888;
  font-size: 0.8rem;
}

/* Playback Controls */
.playback-controls {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.75rem;
  background: #2a2a2a;
  border-radius: 8px;
  flex-shrink: 0;
}

.control-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: #444;
  border: none;
  border-radius: 6px;
  color: #fff;
  cursor: pointer;
  transition: all 0.2s;
}

.control-button .button-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
}

/* Play button icon */
.play-icon {
  position: relative;
  width: 0;
  height: 0;
}

.play-triangle {
  width: 0;
  height: 0;
  border-left: 8px solid #fff;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  margin-left: 2px;
}

/* Pause button icon */
.pause-icon {
  display: flex;
  gap: 2px;
  align-items: center;
  justify-content: center;
}

.pause-bar {
  width: 3px;
  height: 12px;
  background-color: #fff;
  border-radius: 1px;
}

/* Loop button icon */
.loop-icon {
  position: relative;
  width: 14px;
  height: 14px;
}

.loop-circle {
  width: 12px;
  height: 12px;
  border: 2px solid #fff;
  border-radius: 50%;
  border-top-color: transparent;
  border-right-color: transparent;
  position: absolute;
  top: 1px;
  left: 1px;
}

.loop-arrow {
  position: absolute;
  top: 0;
  right: 2px;
  width: 0;
  height: 0;
  border-left: 3px solid transparent;
  border-right: 3px solid transparent;
  border-bottom: 4px solid #fff;
}

.control-button:hover {
  background: #555;
}

.control-button.playing {
  background: #007bff;
}

.control-button.active {
  background: #28a745;
}

.control-button:disabled {
  background: #333;
  color: #666;
  cursor: not-allowed;
}

.time-display-container {
  display: flex;
  flex-direction: row;
  gap: 1rem;
  margin-left: auto;
  align-items: center;
}

.zoom-controls {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  margin-right: 0.75rem;
  padding-right: 0.75rem;
  border-right: 1px solid #444;
}

.zoom-button {
  background: #333;
  border: 1px solid #555;
  border-radius: 4px;
  color: #fff;
  cursor: pointer;
  padding: 4px 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  min-width: 28px;
  height: 28px;
}

.zoom-button:hover {
  background: #444;
  border-color: #666;
  transform: translateY(-1px);
}

.zoom-button:active {
  transform: translateY(0);
  background: #222;
}

.zoom-button svg {
  width: 16px;
  height: 16px;
}

.duration-control-inline {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.8rem;
}

.duration-input-inline {
  width: 60px;
  padding: 2px 4px;
  background: #333;
  border: 1px solid #555;
  border-radius: 3px;
  color: #fff;
  font-size: 0.8rem;
  text-align: center;
}

.duration-unit-inline {
  color: #888;
  font-size: 0.8rem;
}

.duration-reset-inline {
  background: transparent;
  border: none;
  color: #888;
  cursor: pointer;
  padding: 2px;
  border-radius: 3px;
}

.duration-reset-inline:hover {
  color: #fff;
  background: #444;
}

.time-display {
  font-family: 'Courier New', monospace;
  font-size: 0.9rem;
  color: #ccc;
  text-align: right;
}

/* Timeline */
.clip-editor-page .timeline-container {
  background: #1a1a1a;
  border: 1px solid #444;
  border-radius: 8px;
  overflow-x: auto;
  overflow-y: hidden;
  flex-shrink: 0;
  height: 220px;
  padding: 10px;
  position: relative;
}

/* Timeline scrollable area */
.timeline-scrollable {
  position: relative;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}

/* Fixed timeline elements (ruler and playhead) */
.timeline-fixed-layer {
  position: absolute;
  top: 10px;
  left: 10px;
  right: 10px;
  height: 40px;
  background: #1a1a1a;
  z-index: 10;
  pointer-events: auto;
  border-bottom: 1px solid #333;
  cursor: pointer;
}

.timeline-fixed-layer:active {
  cursor: grabbing;
}

/* Scrollable timeline content */
.timeline-content {
  padding-top: 40px; /* Space for fixed ruler */
  min-height: 100%;
}

.clip-editor-page .timeline-container canvas {
  display: block;
}

/* Tools Panel */
.tools-panel {
  display: flex;
  gap: 2rem;
  padding: 1rem;
  background: #2a2a2a;
  border-radius: 8px;
  flex-shrink: 0;
}

.tool-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.tool-group h3 {
  margin: 0 0 0.5rem 0;
  font-size: 0.9rem;
  color: #ccc;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.tool-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: #444;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.8rem;
  transition: background-color 0.2s;
}

.tool-button:hover {
  background: #555;
}

.tool-button:disabled {
  background: #333;
  color: #666;
  cursor: not-allowed;
}

.shortcuts {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  font-size: 0.8rem;
  color: #ccc;
}

.shortcuts kbd {
  background: #444;
  color: #fff;
  padding: 0.2rem 0.4rem;
  border-radius: 3px;
  font-family: 'Courier New', monospace;
  font-size: 0.7rem;
  margin-right: 0.5rem;
  border: 1px solid #666;
}

/* Loading */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  gap: 1rem;
  background: #1a1a1a;
  color: #fff;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #444;
  border-top: 4px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Responsive Design */
@media (max-width: 1200px) {
  .tools-panel {
    flex-direction: column;
    gap: 1rem;
  }
  
  .tool-group {
    flex-direction: row;
    align-items: center;
    gap: 1rem;
  }
  
  .shortcuts {
    flex-direction: row;
  }
}

@media (max-width: 768px) {
  .clip-editor-header {
    padding: 0.5rem 1rem;
  }
  
  .clip-editor-title {
    font-size: 1.2rem;
  }
  
  .clip-editor-main {
    padding: 0.5rem;
  }
  
  .playback-controls {
    padding: 0.5rem;
  }
  
  .clip-editor-page .timeline-container {
    height: 180px;
  }
  
  .tools-panel {
    padding: 0.5rem;
  }
}

/* Timeline specific styles */
.konvajs-content {
  background: transparent !important;
}

/* Custom scrollbar for timeline */
.clip-editor-page .timeline-container::-webkit-scrollbar {
  height: 8px;
}

.clip-editor-page .timeline-container::-webkit-scrollbar-track {
  background: #2a2a2a;
  border-radius: 4px;
}

.clip-editor-page .timeline-container::-webkit-scrollbar-thumb {
  background: #555;
  border-radius: 4px;
}

.clip-editor-page .timeline-container::-webkit-scrollbar-thumb:hover {
  background: #666;
}

/* Shape overlay styles */
.shape-overlay {
  pointer-events: none;
}

/* Text overlay styles */
.text-overlay {
  pointer-events: none;
}

.shape-element {
  pointer-events: all;
  position: relative;
  -webkit-user-select: none;
          user-select: none;
  transition: box-shadow 0.2s ease;
}

.shape-element.selected.outline {
  box-shadow: 0 0 0 2px #007bff, 0 0 8px rgba(0, 123, 255, 0.3);
}

.shape-element.selected.fill {
  box-shadow: inset 0 0 0 2px #007bff, 0 0 8px rgba(0, 123, 255, 0.3);
}

.shape-element.selected.blur {
  box-shadow: 0 0 0 2px #007bff, 0 0 8px rgba(0, 123, 255, 0.3);
}

.shape-element:hover:not(.selected) {
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.5);
}

.shape-element.outline:hover {
  background-color: rgba(255, 0, 0, 0.2) !important; /* More visible on hover */
}

/* Text element styles */
.text-element {
  pointer-events: all;
  position: relative;
  -webkit-user-select: none;
          user-select: none;
  transition: text-shadow 0.2s ease;
  display: inline-block;
}

.text-element.selected {
  text-shadow: 0 0 0 2px #007bff, 0 0 8px rgba(0, 123, 255, 0.3);
}

.text-element:hover:not(.selected) {
  text-shadow: 0 0 0 1px rgba(255, 255, 255, 0.5);
}

/* Transformation handles */
.transform-handle {
  position: absolute;
  background: #007bff;
  border: 2px solid #fff;
  border-radius: 50%;
  width: 8px;
  height: 8px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  z-index: 20;
}

.transform-handle:hover {
  background: #0056b3;
  transform: scale(1.2);
}

/* Corner handles */
.corner-handle.top-left {
  top: -6px;
  left: -6px;
  cursor: nw-resize;
}

.corner-handle.top-right {
  top: -6px;
  right: -6px;
  cursor: ne-resize;
}

.corner-handle.bottom-left {
  bottom: -6px;
  left: -6px;
  cursor: sw-resize;
}

.corner-handle.bottom-right {
  bottom: -6px;
  right: -6px;
  cursor: se-resize;
}

/* Edge handles */
.edge-handle.top {
  top: -6px;
  left: 50%;
  transform: translateX(-50%);
  cursor: n-resize;
}

.edge-handle.right {
  right: -6px;
  top: 50%;
  transform: translateY(-50%);
  cursor: e-resize;
}

.edge-handle.bottom {
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%);
  cursor: s-resize;
}

.edge-handle.left {
  left: -6px;
  top: 50%;
  transform: translateY(-50%);
  cursor: w-resize;
}

/* Rotation handle */
.rotation-handle {
  top: -20px;
  left: 50%;
  transform: translateX(-50%);
  background: #28a745;
  cursor: grab;
  width: 12px;
  height: 12px;
  border-radius: 6px;
}

.rotation-handle:hover {
  background: #1e7e34;
  cursor: grabbing;
}

.rotation-handle:active {
  cursor: grabbing;
}

/* Mode selector dropdown styles */
.mode-dropdown .mode-option:hover {
  background: #444 !important;
}

.mode-dropdown .mode-option.active {
  background: #007bff !important;
}

.mode-dropdown .mode-option {
  transition: background-color 0.2s ease;
}`, "",{"version":3,"sources":["webpack://./src/ClipEditor.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,iDAAiD;AACjD;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,iCAAiC;EACjC,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,6BAA6B;EAC7B,+BAA+B;EAC/B,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,WAAW;EACX,iBAAiB;AACnB;;AAEA,aAAa;AACb;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,aAAa;EACb,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,iDAAiD;AACjD;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,iBAAiB,EAAE,0BAA0B;EAC7C,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,qCAAqC;EACrC,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,6BAA6B;AAC7B;EACE,kCAAkC;AACpC;;AAEA,kCAAkC;AAClC;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,oBAAoB;AACtB;;AAEA,wBAAwB;AACxB;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,iDAAiD,EAAE,0BAA0B;AAC/E;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;EACjB,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,+CAA+C;AACjD;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,SAAS;EACT,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,sCAAsC;AACxC","sourcesContent":[".clip-editor-page {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  background-color: #1a1a1a;\n  color: #fff;\n  overflow: hidden;\n}\n\n.clip-editor-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem 2rem;\n  background: #2a2a2a;\n  border-bottom: 1px solid #444;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.3);\n  flex-shrink: 0;\n}\n\n.clip-editor-title {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin: 0;\n  color: #fff;\n  font-size: 1.5rem;\n  font-weight: 600;\n}\n\n.clip-editor-title .icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  background: linear-gradient(135deg, #007bff, #0056b3);\n  border-radius: 8px;\n  color: white;\n}\n\n.header-actions {\n  display: flex;\n  gap: 1rem;\n}\n\n.back-button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  background: #6c757d;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: background-color 0.2s;\n}\n\n.back-button:hover {\n  background: #5a6268;\n}\n\n.clip-editor-main {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  padding: 0.5rem;\n  gap: 0.5rem;\n}\n\n/* Video Canvas */\n.video-canvas-container {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #000;\n  border-radius: 8px;\n  overflow: hidden;\n  min-height: 300px;\n  max-height: 60vh;\n}\n\n/* Custom scrollbars for video canvas container */\n.video-canvas-container::-webkit-scrollbar {\n  width: 12px;\n  height: 12px;\n}\n\n.video-canvas-container::-webkit-scrollbar-track {\n  background: #1a1a1a;\n  border-radius: 6px;\n}\n\n.video-canvas-container::-webkit-scrollbar-thumb {\n  background: #444;\n  border-radius: 6px;\n  border: 2px solid #1a1a1a;\n}\n\n.video-canvas-container::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n.video-canvas-container::-webkit-scrollbar-corner {\n  background: #1a1a1a;\n}\n\n.video-preview {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  background: #000;\n  min-width: min-content;\n  min-height: min-content;\n}\n\n.video-loading {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n  color: #ccc;\n  z-index: 10;\n}\n\n.video-loading p {\n  margin: 0;\n  font-size: 1rem;\n}\n\n.video-loading small {\n  color: #888;\n  font-size: 0.8rem;\n}\n\n/* Playback Controls */\n.playback-controls {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 0.75rem;\n  background: #2a2a2a;\n  border-radius: 8px;\n  flex-shrink: 0;\n}\n\n.control-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  background: #444;\n  border: none;\n  border-radius: 6px;\n  color: #fff;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.control-button .button-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n}\n\n/* Play button icon */\n.play-icon {\n  position: relative;\n  width: 0;\n  height: 0;\n}\n\n.play-triangle {\n  width: 0;\n  height: 0;\n  border-left: 8px solid #fff;\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  margin-left: 2px;\n}\n\n/* Pause button icon */\n.pause-icon {\n  display: flex;\n  gap: 2px;\n  align-items: center;\n  justify-content: center;\n}\n\n.pause-bar {\n  width: 3px;\n  height: 12px;\n  background-color: #fff;\n  border-radius: 1px;\n}\n\n/* Loop button icon */\n.loop-icon {\n  position: relative;\n  width: 14px;\n  height: 14px;\n}\n\n.loop-circle {\n  width: 12px;\n  height: 12px;\n  border: 2px solid #fff;\n  border-radius: 50%;\n  border-top-color: transparent;\n  border-right-color: transparent;\n  position: absolute;\n  top: 1px;\n  left: 1px;\n}\n\n.loop-arrow {\n  position: absolute;\n  top: 0;\n  right: 2px;\n  width: 0;\n  height: 0;\n  border-left: 3px solid transparent;\n  border-right: 3px solid transparent;\n  border-bottom: 4px solid #fff;\n}\n\n.control-button:hover {\n  background: #555;\n}\n\n.control-button.playing {\n  background: #007bff;\n}\n\n.control-button.active {\n  background: #28a745;\n}\n\n.control-button:disabled {\n  background: #333;\n  color: #666;\n  cursor: not-allowed;\n}\n\n.time-display-container {\n  display: flex;\n  flex-direction: row;\n  gap: 1rem;\n  margin-left: auto;\n  align-items: center;\n}\n\n.zoom-controls {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  margin-right: 0.75rem;\n  padding-right: 0.75rem;\n  border-right: 1px solid #444;\n}\n\n.zoom-button {\n  background: #333;\n  border: 1px solid #555;\n  border-radius: 4px;\n  color: #fff;\n  cursor: pointer;\n  padding: 4px 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  min-width: 28px;\n  height: 28px;\n}\n\n.zoom-button:hover {\n  background: #444;\n  border-color: #666;\n  transform: translateY(-1px);\n}\n\n.zoom-button:active {\n  transform: translateY(0);\n  background: #222;\n}\n\n.zoom-button svg {\n  width: 16px;\n  height: 16px;\n}\n\n.duration-control-inline {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  font-size: 0.8rem;\n}\n\n.duration-input-inline {\n  width: 60px;\n  padding: 2px 4px;\n  background: #333;\n  border: 1px solid #555;\n  border-radius: 3px;\n  color: #fff;\n  font-size: 0.8rem;\n  text-align: center;\n}\n\n.duration-unit-inline {\n  color: #888;\n  font-size: 0.8rem;\n}\n\n.duration-reset-inline {\n  background: transparent;\n  border: none;\n  color: #888;\n  cursor: pointer;\n  padding: 2px;\n  border-radius: 3px;\n}\n\n.duration-reset-inline:hover {\n  color: #fff;\n  background: #444;\n}\n\n.time-display {\n  font-family: 'Courier New', monospace;\n  font-size: 0.9rem;\n  color: #ccc;\n  text-align: right;\n}\n\n/* Timeline */\n.clip-editor-page .timeline-container {\n  background: #1a1a1a;\n  border: 1px solid #444;\n  border-radius: 8px;\n  overflow-x: auto;\n  overflow-y: hidden;\n  flex-shrink: 0;\n  height: 220px;\n  padding: 10px;\n  position: relative;\n}\n\n/* Timeline scrollable area */\n.timeline-scrollable {\n  position: relative;\n  height: 100%;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n/* Fixed timeline elements (ruler and playhead) */\n.timeline-fixed-layer {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  right: 10px;\n  height: 40px;\n  background: #1a1a1a;\n  z-index: 10;\n  pointer-events: auto;\n  border-bottom: 1px solid #333;\n  cursor: pointer;\n}\n\n.timeline-fixed-layer:active {\n  cursor: grabbing;\n}\n\n/* Scrollable timeline content */\n.timeline-content {\n  padding-top: 40px; /* Space for fixed ruler */\n  min-height: 100%;\n}\n\n.clip-editor-page .timeline-container canvas {\n  display: block;\n}\n\n/* Tools Panel */\n.tools-panel {\n  display: flex;\n  gap: 2rem;\n  padding: 1rem;\n  background: #2a2a2a;\n  border-radius: 8px;\n  flex-shrink: 0;\n}\n\n.tool-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.tool-group h3 {\n  margin: 0 0 0.5rem 0;\n  font-size: 0.9rem;\n  color: #ccc;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.tool-button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  background: #444;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.8rem;\n  transition: background-color 0.2s;\n}\n\n.tool-button:hover {\n  background: #555;\n}\n\n.tool-button:disabled {\n  background: #333;\n  color: #666;\n  cursor: not-allowed;\n}\n\n.shortcuts {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  font-size: 0.8rem;\n  color: #ccc;\n}\n\n.shortcuts kbd {\n  background: #444;\n  color: #fff;\n  padding: 0.2rem 0.4rem;\n  border-radius: 3px;\n  font-family: 'Courier New', monospace;\n  font-size: 0.7rem;\n  margin-right: 0.5rem;\n  border: 1px solid #666;\n}\n\n/* Loading */\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  gap: 1rem;\n  background: #1a1a1a;\n  color: #fff;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #444;\n  border-top: 4px solid #007bff;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n  .tools-panel {\n    flex-direction: column;\n    gap: 1rem;\n  }\n  \n  .tool-group {\n    flex-direction: row;\n    align-items: center;\n    gap: 1rem;\n  }\n  \n  .shortcuts {\n    flex-direction: row;\n  }\n}\n\n@media (max-width: 768px) {\n  .clip-editor-header {\n    padding: 0.5rem 1rem;\n  }\n  \n  .clip-editor-title {\n    font-size: 1.2rem;\n  }\n  \n  .clip-editor-main {\n    padding: 0.5rem;\n  }\n  \n  .playback-controls {\n    padding: 0.5rem;\n  }\n  \n  .clip-editor-page .timeline-container {\n    height: 180px;\n  }\n  \n  .tools-panel {\n    padding: 0.5rem;\n  }\n}\n\n/* Timeline specific styles */\n.konvajs-content {\n  background: transparent !important;\n}\n\n/* Custom scrollbar for timeline */\n.clip-editor-page .timeline-container::-webkit-scrollbar {\n  height: 8px;\n}\n\n.clip-editor-page .timeline-container::-webkit-scrollbar-track {\n  background: #2a2a2a;\n  border-radius: 4px;\n}\n\n.clip-editor-page .timeline-container::-webkit-scrollbar-thumb {\n  background: #555;\n  border-radius: 4px;\n}\n\n.clip-editor-page .timeline-container::-webkit-scrollbar-thumb:hover {\n  background: #666;\n}\n\n/* Shape overlay styles */\n.shape-overlay {\n  pointer-events: none;\n}\n\n/* Text overlay styles */\n.text-overlay {\n  pointer-events: none;\n}\n\n.shape-element {\n  pointer-events: all;\n  position: relative;\n  user-select: none;\n  transition: box-shadow 0.2s ease;\n}\n\n.shape-element.selected.outline {\n  box-shadow: 0 0 0 2px #007bff, 0 0 8px rgba(0, 123, 255, 0.3);\n}\n\n.shape-element.selected.fill {\n  box-shadow: inset 0 0 0 2px #007bff, 0 0 8px rgba(0, 123, 255, 0.3);\n}\n\n.shape-element.selected.blur {\n  box-shadow: 0 0 0 2px #007bff, 0 0 8px rgba(0, 123, 255, 0.3);\n}\n\n.shape-element:hover:not(.selected) {\n  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.5);\n}\n\n.shape-element.outline:hover {\n  background-color: rgba(255, 0, 0, 0.2) !important; /* More visible on hover */\n}\n\n/* Text element styles */\n.text-element {\n  pointer-events: all;\n  position: relative;\n  user-select: none;\n  transition: text-shadow 0.2s ease;\n  display: inline-block;\n}\n\n.text-element.selected {\n  text-shadow: 0 0 0 2px #007bff, 0 0 8px rgba(0, 123, 255, 0.3);\n}\n\n.text-element:hover:not(.selected) {\n  text-shadow: 0 0 0 1px rgba(255, 255, 255, 0.5);\n}\n\n/* Transformation handles */\n.transform-handle {\n  position: absolute;\n  background: #007bff;\n  border: 2px solid #fff;\n  border-radius: 50%;\n  width: 8px;\n  height: 8px;\n  cursor: pointer;\n  user-select: none;\n  z-index: 20;\n}\n\n.transform-handle:hover {\n  background: #0056b3;\n  transform: scale(1.2);\n}\n\n/* Corner handles */\n.corner-handle.top-left {\n  top: -6px;\n  left: -6px;\n  cursor: nw-resize;\n}\n\n.corner-handle.top-right {\n  top: -6px;\n  right: -6px;\n  cursor: ne-resize;\n}\n\n.corner-handle.bottom-left {\n  bottom: -6px;\n  left: -6px;\n  cursor: sw-resize;\n}\n\n.corner-handle.bottom-right {\n  bottom: -6px;\n  right: -6px;\n  cursor: se-resize;\n}\n\n/* Edge handles */\n.edge-handle.top {\n  top: -6px;\n  left: 50%;\n  transform: translateX(-50%);\n  cursor: n-resize;\n}\n\n.edge-handle.right {\n  right: -6px;\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: e-resize;\n}\n\n.edge-handle.bottom {\n  bottom: -6px;\n  left: 50%;\n  transform: translateX(-50%);\n  cursor: s-resize;\n}\n\n.edge-handle.left {\n  left: -6px;\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: w-resize;\n}\n\n/* Rotation handle */\n.rotation-handle {\n  top: -20px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: #28a745;\n  cursor: grab;\n  width: 12px;\n  height: 12px;\n  border-radius: 6px;\n}\n\n.rotation-handle:hover {\n  background: #1e7e34;\n  cursor: grabbing;\n}\n\n.rotation-handle:active {\n  cursor: grabbing;\n}\n\n/* Mode selector dropdown styles */\n.mode-dropdown .mode-option:hover {\n  background: #444 !important;\n}\n\n.mode-dropdown .mode-option.active {\n  background: #007bff !important;\n}\n\n.mode-dropdown .mode-option {\n  transition: background-color 0.2s ease;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
